var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgScreenshareIconBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67.891,
    height: 56.475,
    viewBox: "0 0 67.891 56.475",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screenshar-icon-blue",
    transform: "translate(0 -37.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(0 37.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M0,123.516v31.608a1.922,1.922,0,0,0,1.922,1.922H19.179v4.187H16.087a1.922,1.922,0,1,0,0,3.844H36.557a1.922,1.922,0,1,0,0-3.844H33.465v-4.187H50.722a1.922,1.922,0,0,0,1.922-1.922V123.516a1.922,1.922,0,0,0-1.922-1.922H1.922A1.922,1.922,0,0,0,0,123.516Zm29.621,37.529h-6.6v-4h6.6v4ZM3.844,125.438H48.8V153.2H3.844Z",
    transform: "translate(0 -108.603)",
    fill: "#43bdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M151.792,70.649V39.04a1.922,1.922,0,0,0-1.922-1.922h-48.8a1.922,1.922,0,0,0-1.922,1.922V46.46a1.922,1.922,0,0,0,3.844,0v-5.5h44.955V68.726h-5.79a1.922,1.922,0,1,0,0,3.844h7.712A1.922,1.922,0,0,0,151.792,70.649Z",
    transform: "translate(-83.901 -37.118)",
    fill: "#43bdd8"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScreenshareIconBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/screenshare-icon-blue.85f37fd0.svg";
export { ForwardRef as ReactComponent };